import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4 12.7 10.7 6l-.7-.7L3.3 12zM12.3.4l-.7.7 3.3 3.3.7-.7zm-1.9 1.8 3.4 3.3.7-.7-3.4-3.4zM.6 12l-.4 3.8 3.8-.4L13.4 6 10 2.5zm.7 2.7.2-1.9 1.7 1.7zm2.8-.7L2 11.9 10 4l2 2.1z" />
  </svg>
);
const SvgPencil = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="pencil" {...props} />;
export default SvgPencil;
